import targeting from './targeting-factory';
export const { evaluateTargeting } = targeting;
export { TargetingFlag, TargetingParameters } from './typings/targeting';
